import React, { FC, useEffect, useRef, useState } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";



export const ADIContactFormWidget: FC<any> = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "//go.adiglobal.com/js/forms2/js/forms2.min.js";
        script.defer = true;
        document.body.appendChild(script);
        script.onload = () => {
            (window as any).MktoForms2.loadForm("//go.adiglobal.com", "131-WTZ-295", 3515);
          };
    }, []);

    return (
        <>
            <div className="contact_us left">
                <h1>Contact Us</h1>
                <p>Fill out the form below, and a representative will respond to your request.</p>
                <form id="mktoForm_3515"></form>
            </div>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ADIContactFormWidget,
    definition: {
        group: "Common",
        displayName: "ADI Contact US form",
        fieldDefinitions: [],
    },
};

export default widgetModule;
